import React, { useEffect, useState } from "react";
import { collection, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import {Typography, Table, TableHead, TableRow, TableCell, TableBody, Button, TableContainer, Paper, TablePagination } from "@mui/material";

const MovieList = () => {
  const [movies, setMovies] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchMovies = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "movies"));
        const movieData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMovies(movieData);
      } catch (error) {
        console.error("Error fetching movies:", error);
      }
    };

    fetchMovies();
  }, []);

  const approveMovie = async (id) => {
    try {
      const movieRef = doc(db, "movies", id);
      await updateDoc(movieRef, { publish: "1" });
      setMovies(movies.map((movie) => (movie.id === id ? { ...movie, publish: 1 } : movie)));
    } catch (error) {
      console.error("Error approving movie:", error);
    }
  };

  const deleteMovie = async (id) => {
    try {
      const movieRef = doc(db, "movies", id);
      await deleteDoc(movieRef);
      setMovies(movies.filter((movie) => movie.id !== id));
    } catch (error) {
      console.error("Error deleting movie:", error);
    }
  };

  // Handle page change
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <Typography variant="h4" sx={{ marginBottom: 2 }}>
      Movie Management
            </Typography>
      <TableContainer component={Paper}>
        <Table>
           <TableHead sx={{ backgroundColor: "#7d1aed" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>S. No</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Title</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Genre</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Director</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Duration</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Cast</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Crew</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Target Funding</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Unit Price</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {movies.length > 0 ? (
              movies
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((movie,index) => (
                  <TableRow key={movie.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{movie.title}</TableCell>
                    <TableCell>{movie.genre}</TableCell>
                    <TableCell>{movie.director}</TableCell>
                    <TableCell>{movie.duration}</TableCell>
                    <TableCell>{movie.cast ? movie.cast.join(", ") : "N/A"}</TableCell>
                    <TableCell>{movie.crew ? movie.crew.join(", ") : "N/A"}</TableCell>
                    <TableCell>${movie.targetFunding?.toLocaleString()}</TableCell>
                    <TableCell>{movie.unitPrice}</TableCell>
                    <TableCell>{movie.publish === 1 ? "Approved" : "Pending"}</TableCell>
                    <TableCell>
                      {movie.publish !== 1 && (
                        <Button variant="contained" color="primary" onClick={() => approveMovie(movie.id)}>
                          Approve
                        </Button>
                      )}
                      <Button variant="contained" color="secondary" onClick={() => deleteMovie(movie.id)}>
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  No movies found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination Component */}
      <TablePagination
        component="div"
        count={movies.length}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 20]}
      />
    </div>
  );
};

export default MovieList;
